import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserLogin } from '../interfaces/user-login';
import { UserSession } from '../interfaces/user-session';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, tap } from 'rxjs';
import { RequestService } from 'app/shared/services/request.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedUserSubject: BehaviorSubject<UserSession | null>;
  private loggedUserSubjectLaravel: BehaviorSubject<any | null>;

  constructor(
    private http: HttpClient,
    private readonly requestService: RequestService
  ) {
    this.loggedUserSubject = new BehaviorSubject<UserSession | null>(null);
    this.loggedUserSubjectLaravel = new BehaviorSubject<any | null>(null);
  }

  requestUser(): Observable<UserSession | null> {
    if (this.loggedUserSubject.value) {
      // Se c'è già un utente loggato, restituisco il valore corrente come Observable
      return of(this.loggedUserSubject.value);
    }
  
    // Altrimenti faccio la richiesta HTTP
    return this.requestService.getRequest('auth/user').pipe(
      tap((resp) => {
        const user = resp?.data || null;
        this.loggedUserSubject.next(user);
      }),
      map(resp => resp?.data || null),
      catchError(() => {
        this.loggedUserSubject.next(null);
        return of(null);
      })
    );
  }
  

  loginUser(credentials: UserLogin): Observable<UserSession | null | undefined> {
    return new Observable(observer => {
      this.requestService.postRequest('auth/login', credentials, undefined, undefined, false).subscribe({
        next: (resp) => {
          if (resp.data) {
            const user: UserSession = resp.data;
            this.loggedUserSubject.next(user);
            this.requestService.postRequest('accedi', credentials, undefined, undefined, false).subscribe({
              next: (resp) => {
                if (resp.data) {
                  const laravelUser: UserSession = resp.data;
                  this.loggedUserSubjectLaravel.next(laravelUser);
                  observer.next(user);
                  observer.complete();
                } else {
                  observer.error();
                  observer.complete();
                }
              },
              error: (error) => {
                observer.error(error);
                observer.complete();
              }
            })
          } else {
            observer.error();
            observer.complete();
          }
        },
        error: (error) => {
          console.log(error)
          observer.error(error);
          observer.complete();
        }
      })
    })
  }

  public getCurrentUserAsync(): Observable<UserSession | null> {
    return this.requestUser();
  }

  public getCurrentUser(): UserSession | null {
    return this.loggedUserSubject.value;
  }

  public logout(): void {
    this.requestService.postRequest('auth/logout', null).subscribe({
      next: (resp) => {
        this.loggedUserSubject.next(null);
        this.loggedUserSubjectLaravel.next(null);
        window.location.href = "/";
      }
    });
  }


}
